<template>
  <form>
    <div class="search-wrap">
      <select class="custom-select" id="exampleFormControlSelect1" style="width: clamp(11rem, 15vw, 30%); margin-bottom: 2rem" v-model="date">
        <option value="please-select" >Please select</option>
        <option v-for="i in this.dateRange" :value="i" :key="i" >{{i}}</option>
      </select>
    </div>
  </form>
</template>

<script>

export default {
  data() {
    return {
      hostname: this.$store.state.hostname,
      prefix: `${this.$store.state.extensionName}_${this.$store.state.pluginName}`,
      date: 'please-select',
      currentYear: new Date().getFullYear(),
      dateRange: [],
      countIncrease: 20,
    };
  },
  methods: {
    async search() {
      // Wird aufgerufen beim Suchen
      // Die Variable die hier verändert wird entscheidet darüber ob ein Ergebnis angezeigt wird oder nicht
      // wenn completeLoading auf false steht werden die 3 Roten Ladepunkte in der Mitte angezeigt
      // Wenn scheinbar ewig geladen wird -> die Ladepunkte verschwinden nicht, dann ist diese Funktion vermutlich in der Mitte abgebrochen worden
      this.$store.commit('completeLoading', false);
      if (this.filmid === 0) {
        await this.$store.commit('clearEntries');
      }
      // mit "await" verhindert man dass Prozesse Parallel ausgeführt werden
      // Um "await" zu benutzen muss die methode asynchron sein -> async vor dem Methodennamen
      await this.$store.commit('updateError', 0);
      await this.$store.commit('updateCounter', 0);
      await this.fetchIdArray();
      if (await this.nextItems()) {
        await this.fetchItems();
      }
      if (this.filmid === 0 && this.personid === 0 && this.companyid === 0) {
        await this.$router.push({ path: this.$store.state.site, query: await this.buildVueURL() });
      } else {
        this.filmid = 0;
      }
      await this.$store.commit('completeLoading', true);
    },
    async buildControllerURL() {
      // Baut eine URL zusammen mit der die Suchparameter an den Filmcontroller übergeben werden
      let URLParams = `https://${this.hostname}/?&`;
      if (this.date !== 'please-select') {
        URLParams += `${this.prefix}[filter][date]=${this.date}&`;
      }
      URLParams += `${this.prefix}[filter][answerType]=next_gen&`;
      URLParams += 'type=2753189517';
      this.$store.commit('updateURL', URLParams);
      return URLParams;
    },
    async fetchItems() {
      await fetch(
        //  mit dem Answer Type [answerType]=items und der Übergabe eines Arrays das IDs enthält [items]=${await this.nextItems()} werden die Daten zu Filmen geladen
        `https://${this.hostname}/?&${this.prefix}[filter][answerType]=items&${this.prefix}[items]=${await this.nextItems()}&type=2753189517`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        },
      )
        .then((response) => response.json())
        .then(async (data) => {
          await this.$store.commit('updateWholeDatabase', data.itemList);
        }).catch(() => {
          this.$store.commit('completeLoading', true);
          this.$store.commit('updateError', 1);
        });
    },
    async fetchIdArray() {
      // Fordert ein Array mit IDs von Filmen an, die zu den eingegebenen Suchkriterien passen
      // Bei diesem Fetch werden keine Filmdaten geladen, sondern ausschließlich die IDs
      // Die Filmdaten werden in fetchItems geladen
      await fetch(
        await this.buildControllerURL(),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        },
      )
        .then((response) => response.json())
        .then(async (data) => {
          await this.$store.commit('updateIdForSearchRequest', data.matchingIDs);
        }).catch(() => {
          this.$store.commit('completeLoading', true);
          this.$store.commit('updateError', 1);
        });
    },
    async nextItems() {
      // Hilfsfunktion von fetchItems()
      // Sucht die nächsten filmIDs raus anhand der passsenden FilmIDs die mit fetchIdArray abgefragt wurden
      if (this.$store.state.idForSearchRequest.length === 0) {
        return null;
      }
      const tempArray = [];
      for (let i = 0; i < this.countIncrease; i += 1) {
        if (this.$store.state.idForSearchRequest[this.$store.state.counter + i] != null) {
          tempArray.push(this.$store.state.idForSearchRequest[this.$store.state.counter + i]);
        }
      }
      return tempArray;
    },
  },
  // es folgen Lifecycle Hooks
  // das sind Methoden die immer zu bestimmten Aktionen ausgeführt werden
  async created() {
    // Beim Seitenaufruf wurd dieser Hook ausgeführt
    // die Index.html in der das CSS File sonst angfezogen wird kann nicht verwendet werden, daher wird hier das css File reingemogelt
    for (let i = 1998; i <= this.currentYear; i += 1) {
      this.dateRange.push(i);
    }
    this.dateRange = this.dateRange.reverse();
    const head = document.getElementsByTagName('HEAD')[0];
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `https://${this.hostname}/Css/styles.css`;
    head.appendChild(link);
    await this.search();
  },
  // ein Watcher kann beobachten ob sich Variablen in anderen Komponenten ändern
  watch: {
    // Dieser Watcher beobachtet die im store gespeicherte Variable counter
    // diese wird verändert sobald der user auf "show more" klickt, dann sollen mehr Filme geladen werden
    '$store.state.counter': async function () {
      await this.fetchItems();
    },
    async date() {
      await this.search();
    },
  },
};
</script>

<style>

.date .form-group .search-criteria{
  font-size: 1rem;
  font-weight: bold;
  line-height: 1rem;
}

#start-date-box{
  text-align: left;
}

#end-date-box{
  text-align: right;
}
.range-slider {
  flex-direction: column;
  width: calc(100% - 25px);
  position: relative;
  height: .6rem;
  display: flex;
  justify-content: center;
}
.year-wrapper span{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.slider{
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  height: 0;
  pointer-events: none;
  position: absolute;
  left: 0;
  bottom: 0;
  /* als alternative ausblenden? */
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.slider:focus {
  outline: none;
}
.slider::-webkit-slider-runnable-track {
  outline: 0;
  -webkit-appearance: none;
  background: #3c3c3c;
  height: 5px;
  cursor: pointer;
  border-radius: 1px;
  box-shadow: none;
  border: 0;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  pointer-events: auto;
  z-index: 2;
  position: relative;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #3c3c3c;
  cursor: pointer;
  margin-top: -7px;
}
.slider::-moz-range-track {
  cursor: default;
  -moz-appearance: none;
  outline: 0;
  height: 5px;
  background: #3c3c3c;
}
.slider::-moz-range-thumb {
  z-index: 2;
  -moz-appearance: none;
  pointer-events: auto;
  background: #3c3c3c;
}
/* Funktion muss überprüft werden */
.slider::-ms-track{
  height: 5px;
  background: #3c3c3c;
}
.slider::-ms-thumb{
  z-index: 2;
  pointer-events: auto;
  background: #3c3c3c;
}

#end-date-slider.slider::-moz-range-track{
  background: transparent;
/*  Das muss so; sonst sieht der Slider im Firefox seltsam aus*/
}

.genre .form-group::-webkit-scrollbar-thumb, .category  .form-group::-webkit-scrollbar-thumb {
  background: #ffffff !important;
  border-radius: 5px;
}
.genre .form-group::-webkit-scrollbar-track, .category .form-group::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #ff0000 !important;
  border: 2px solid #3c3c3c;
}
.genre .form-group::-webkit-scrollbar, .category .form-group::-webkit-scrollbar {
  width: 10px;
}

.genre .form-group, .category .form-group{
  scrollbar-width: 10px;
  scrollbar-color: #fff rgba(0, 0, 0, 0.17);
}
</style>
